<fuse-card class="flex h-full flex-col">
  <div class="flex items-center gap-2 border-b px-4 py-3">
    <span class="flex-1 text-base font-semibold text-gray-900">My Active Surveys</span>
    <a
      routerLink="/communication/surveys"
      [queryParams]="{ _ref: 'dashboard' }"
      class="rounded border border-transparent px-2 py-0.5 text-sm text-gray-400 transition hover:border-gray-200 hover:text-primary"
      >View all</a
    >
  </div>
  <div class="flex-1 overflow-y-auto">
    @if (loading) {
      <div class="flex h-full items-center justify-center">
        <mat-spinner diameter="28" color="primary"></mat-spinner>
      </div>
    }
    @if (surveys.length && !loading) {
      @for (item of surveys; track item.id) {
        <div class="flex cursor-pointer flex-col border-b px-4 py-2 last:border-b-0 hover:bg-gray-50" (click)="openReportModal(item)">
          <!-- Title left, community + dates right -->
          <div class="flex items-center gap-2">
            <span class="min-w-0 flex-1 truncate text-sm font-semibold text-primary">{{ item.title }}</span>
            <div class="flex shrink-0 flex-wrap items-center justify-end gap-1 text-xs">
              @if (item.association?.name) {
                <span class="text-gray-400">{{ item.association?.name }}</span>
              }
              @if (item.published_at) {
                <span class="opacity-30">·</span>
                <span class="text-gray-400">{{ item.published_at | timeAgo }}</span>
              }
              @if (item.expire_at) {
                <span class="opacity-30">·</span>
                <span class="text-amber-500">expires {{ item.expire_at | timeAgo }}</span>
              }
            </div>
          </div>
          <!-- Responses counter -->
          <div class="mt-0.5 flex items-center justify-between">
            <div class="flex items-center gap-1 text-xs text-gray-400">
              <mat-icon fontIcon="how_to_vote" class="icon-size-3.5"></mat-icon>
              <span>Responses</span>
            </div>
            <span class="rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-bold text-blue-600 ring-1 ring-blue-200">
              {{ item.responses_count || 0 }}
            </span>
          </div>
        </div>
      }
    }
    @if (!loading && !surveys.length && !error) {
      <div class="flex h-full flex-col items-center justify-center gap-2 text-gray-400">
        <mat-icon fontIcon="poll" class="opacity-40 icon-size-8"></mat-icon>
        <span class="text-sm font-medium">No active surveys</span>
      </div>
    }
  </div>
</fuse-card>
